import fetch from '../utils/fetch';
import { giftCodeURL } from 'endpoints';

class GiftCodeSDK {

    getAwardCountries = ( awardId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/awards/${ awardId }/countries` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( countries ) => {
                        resolve( countries );
                    } );
                } else {
                    //TODO: Errors
                    reject();
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( err.message );
            } );
        } );
    };

    getProgramLevels = ( programNumber ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/programs/${ programNumber }/levels` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( levels ) => {
                        resolve( levels );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( err.message );
            } );
        } );
    };

}

export default new GiftCodeSDK();